// extracted by mini-css-extract-plugin
export default {"link":"link--g4RhL","link__text":"link__text--e0Mwe"};